import { createSubscriptionDelegationVE } from "../../app/services/eventanilla/createSubscriptionDelegationVE"
import { getAllSubscriptionDelegationsVE } from "../../app/services/eventanilla/getAllSubscriptionDelegationsVE"
import { getAllSubscriptions } from "../../app/services/eventanilla/getAllSubscriptions"
import { getCommSubscriptionDetails } from "../../app/services/eventanilla/getCommSubscriptionDetailsCommunicationVE"
import { getUniqueCustomerSuborganizationNamesVE } from "../../app/services/eventanilla/getUniqueCustomerSuborganizationNamesVE"
import { getUniqueEmailsFromSubscriptionDelegationsVE } from "../../app/services/eventanilla/getUniqueEmailsFromSubscriptionDelegationsVE"
import { updateSubscriptionCommunicationVE } from "../../app/services/eventanilla/updateSubscription"
import { updateSubscriptionDelegationsVE } from "../../app/services/eventanilla/updateSubscriptionDelegationsVE"
import { eventanillaTypes } from "../constants/action-types"
import {
  setErrorTextSnackBar,
  setRequestTextSnackBar,
  setSuccessTextSnackBar,
} from "./app"

export const suscribersStatusVERequest = () => {
  return {
    type: eventanillaTypes.EVENTANILLA_SUBSCRIBER_STATUS_REQUEST,
  }
}

export const suscribersStatusVESuccess = (list) => {
  return {
    type: eventanillaTypes.EVENTANILLA_SUBSCRIBER_STATUS_SUCCESS,
    payload: list || [],
  }
}

export const suscribersStatusOrderByDateVESuccess = (list) => {
  return {
    type: eventanillaTypes.EVENTANILLA_SUBSCRIBER_STATUS_CHANGE_ORDER,
    payload: list || [],
  }
}

export const suscribersDetailsStatusOrderByDateVESuccess = (data) => {
  return {
    type: eventanillaTypes.EVENTANILLA_SUBSCRIBER_DETAILS_CHANGE_ORDER,
    payload: data,
  }
}

export const suscribersStatusVEFailure = (error) => {
  return {
    type: eventanillaTypes.EVENTANILLA_SUBSCRIBER_STATUS_FAILURE,
    payload: error,
  }
}

export const suscribersDetailsVERequest = () => {
  return {
    type: eventanillaTypes.EVENTANILLA_SUBSCRIBER_DETAILS_REQUEST,
  }
}

export const suscribersDetailsVESuccess = (details) => {
  return {
    type: eventanillaTypes.EVENTANILLA_SUBSCRIBER_DETAILS_SUCCESS,
    payload: details,
  }
}

export const suscribersDetailsVEFailure = (error) => {
  return {
    type: eventanillaTypes.EVENTANILLA_SUBSCRIBER_DETAILS_FAILURE,
    payload: error,
  }
}

export const updateSuscribersStatusVESuccess = (subscriberStatus) => {
  return {
    type: eventanillaTypes.EVENTANILLA_UPDATE_SUBSCRIBER_STATUS_SUCCESS,
    payload: subscriberStatus,
  }
}
export const updateSuscribersStatusVESuccessARCA = (subscriberStatus) => {
  return {
    type: eventanillaTypes.EVENTANILLA_UPDATE_SUBSCRIBER_STATUS_SUCCESS_ARCA,
    payload: subscriberStatus,
  }
}
export const updateSuscribersStatusVEFailure = (error) => {
  return {
    type: eventanillaTypes.EVENTANILLA_UPDATE_SUBSCRIBER_STATUS_ERROR,
    payload: error,
  }
}

export const addNewSearchValue = (value) => {
  return {
    type: eventanillaTypes.EVENTANILLA_ADD_SEARCH_VALUE_CUIT,
    payload: value,
  }
}

export const deleteSearchValue = (value) => {
  return {
    type: eventanillaTypes.EVENTANILLA_DELETE_SEARCH_VALUE_CUIT,
    payload: value,
  }
}

export const deleteSearchClientNameValue = (values) => {
  return {
    type: eventanillaTypes.EVENTANILLA_DELETE_SEARCH_VALUE_CLIENT_NAME,
    payload: values,
  }
}

export const deleteSearchStatusValue = (value) => {
  return {
    type: eventanillaTypes.EVENTANILLA_DELETE_SEARCH_VALUE_STATUS,
    payload: value,
  }
}

export const changeSearchClientNames = (listNames) => {
  return {
    type: eventanillaTypes.EVENTANILLA_CHANGE_SEARCH_CLIENT_NAMES,
    payload: listNames,
  }
}

export const changeSearchStatus = (status) => {
  return {
    type: eventanillaTypes.EVENTANILLA_CHANGE_SEARCH_STATUS,
    payload: status,
  }
}

export const loadingOn = () => {
  return {
    type: eventanillaTypes.EVENTANILLA_LOADING_ON,
  }
}

export const loadingOff = () => {
  return {
    type: eventanillaTypes.EVENTANILLA_LOADING_OFF,
  }
}
export const createSubscriptionSuccess = (value) => {
  return {
    type: eventanillaTypes.EVENTANILLA_CREATE_SUBSCRIPTION_SUCCESS,
    payload: value,
  }
}

export const updateSubscriptionSuccess = (value) => {
  return {
    type: eventanillaTypes.EVENTANILLA_UPDATE_SUBSCRIPTION_SUCCESS,
    payload: value,
  }
}

export const getSubscriptionSuccess = (value) => {
  return {
    type: eventanillaTypes.EVENTANILLA_GET_SUBSCRIPTION_SUCCESS,
    payload: value,
  }
}
export const delegationOrderByDateVESuccess = (list) => {
  return {
    type: eventanillaTypes.EVENTANILLA_DELEGATION_DATE_TIME_CHANGE_ORDER,
    payload: list || [],
  }
}
export const addNewSearchValueSubscription = (value) => {
  return {
    type: eventanillaTypes.EVENTANILLA_ADD_SEARCH_VALUE_CUIT_SUBSCRIPTION,
    payload: value,
  }
}
export const deleteSearchValueSubscription = (value) => {
  return {
    type: eventanillaTypes.EVENTANILLA_DELETE_SEARCH_VALUE_CUIT_SUBCRIPTION,
    payload: value,
  }
}
export const changeSearchClientNamesSubscription = (listNames) => {
  return {
    type: eventanillaTypes.EVENTANILLA_CHANGE_SEARCH_CLIENT_NAMES_SUBCRIPTION,
    payload: listNames,
  }
}
export const setSearchEvStatus = (evStatusValues) => ({
  type: eventanillaTypes.EVENTANILLA_SET_SEARCH_EV_STATUS,
  payload: evStatusValues,
})
export const changeSearchUserNamesSubscription = (listNames) => {
  return {
    type: eventanillaTypes.EVENTANILLA_CHANGE_SEARCH_USER_NAMES_SUBCRIPTION,
    payload: listNames,
  }
}

export const deleteSearchClientNameValueSubscription = (values) => {
  return {
    type: eventanillaTypes.EVENTANILLA_DELETE_SEARCH_VALUE_CLIENT_NAME_SUBCRIPTION,
    payload: values,
  }
}

export const deleteSearchUserNameValueSubscription = (values) => {
  return {
    type: eventanillaTypes.EVENTANILLA_DELETE_SEARCH_VALUE_USER_NAME_SUBCRIPTION,
    payload: values,
  }
}

export const setSubscriptionClientNames = (names) => ({
  type: eventanillaTypes.EVENTANILLA_SET_CLIENT_NAMES_SUBSCRIPTION,
  payload: names,
})

export const setSubscriptionUserNames = (names) => ({
  type: eventanillaTypes.EVENTANILLA_SET_USER_NAMES_SUBSCRIPTION,
  payload: names,
})

export const setDateFilter = (date) => ({
  type: eventanillaTypes.EVENTANILLA_SET_DATE_FILTER,
  payload: date,
})

export const clearDateFilter = () => ({
  type: eventanillaTypes.EVENTANILLA_CLEAR_DATE_FILTER,
})
export const setSubscriptionPagination = (pagination) => ({
  type: eventanillaTypes.SET_SUBSCRIPTION_PAGINATION,
  payload: pagination,
})
export const getAllSubscriptionsCommunication = (
  cuitCliente = null,
  customerSuborganizationName = null,
  subscriptionStatus = null,
) => {
  return async (dispatch) => {
    dispatch(loadingOn())
    try {
      const response = await getAllSubscriptions({
        cuitCliente,
        customerSuborganizationName,
        subscriptionStatus,
      })
      dispatch(suscribersStatusVESuccess(response?.data))
    } catch (error) {
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error en un servicio de: Legalcommunications",
          ),
        )
      }
      if (error.response?.data?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error en un servicio de: " +
              error.response?.data?.codeMessageLanguage,
          ),
        )
      }
    }
    dispatch(loadingOff())
  }
}

export const getSubscriptionDetails = (cuitCliente) => {
  return async (dispatch) => {
    try {
      const response = await getCommSubscriptionDetails(cuitCliente)
      dispatch(suscribersDetailsVESuccess(response?.data?.data))
    } catch (error) {
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error en un servicio de: Legalcommunications",
          ),
        )
      }
      if (error.response?.data?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error en un servicio de: " +
              error.response?.data?.codeMessageLanguage,
          ),
        )
      }
    }
  }
}

export const updateSubscription = (subscription) => {
  return async (dispatch) => {
    try {
      dispatch(setRequestTextSnackBar())
      const response = await updateSubscriptionCommunicationVE(subscription)
      dispatch(updateSuscribersStatusVESuccess(response.data.data))
      dispatch(setSuccessTextSnackBar("Cambio de estado éxitoso."))
      return response?.data?.data
    } catch (error) {
      if (error?.response?.status >= 400) {
        const { message } = error.response
        if (message) {
          if (message?.include("CUIT is being used by more than one client"))
            return dispatch(
              setErrorTextSnackBar(
                "El CUIT está siendo utilizada por más de un cliente",
              ),
            )
          if (
            message?.include("communicationSubscriptionVEId") &&
            message?.include("is not found")
          )
            return dispatch(
              setErrorTextSnackBar(
                "No se encontró la suscripción de comunicación",
              ),
            )
        }
      }

      return dispatch(
        setErrorTextSnackBar(
          "Ocurrió un error al actualizar el estado de la suscripción de comunicación",
        ),
      )
    }
  }
}
export const updateSubscriptionARCA = (subscription) => {
  return async (dispatch) => {
    try {
      dispatch(setRequestTextSnackBar())
      const response = await updateSubscriptionCommunicationVE(subscription)
      dispatch(updateSuscribersStatusVESuccessARCA(response.data.data))
      dispatch(setSuccessTextSnackBar("Cambio de estado éxitoso."))
      return response?.data?.data
    } catch (error) {
      if (error?.response?.status >= 400) {
        const { message } = error.response
        if (message) {
          if (message?.include("CUIT is being used by more than one client"))
            return dispatch(
              setErrorTextSnackBar(
                "El CUIT está siendo utilizada por más de un cliente",
              ),
            )
          if (
            message?.include("communicationSubscriptionVEId") &&
            message?.include("is not found")
          )
            return dispatch(
              setErrorTextSnackBar(
                "No se encontró la suscripción de comunicación",
              ),
            )
        }
      }

      return dispatch(
        setErrorTextSnackBar(
          "Ocurrió un error al actualizar el estado de la suscripción de comunicación",
        ),
      )
    }
  }
}

export const createSubsDelegationVE = (body) => {
  return async (dispatch) => {
    try {
      const response = await createSubscriptionDelegationVE(body)
      dispatch(createSubscriptionSuccess(response.data?.data))
      dispatch(setSuccessTextSnackBar("Cuit agregado exitosamente"))
      return response.data?.data
    } catch (error) {
      if (error.response?.status === 400) {
        dispatch(setRequestTextSnackBar())
        dispatch(setErrorTextSnackBar("El CUIT ya se encontraba dado de alta"))
      }
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error en un servicio de: e-Ventanilla",
          ),
        )
      }
      return null
    }
  }
}

export const updateSubsDelegationVE = (body) => {
  return async (dispatch) => {
    try {
      const response = await updateSubscriptionDelegationsVE(body)
      dispatch(updateSubscriptionSuccess(response.data?.data))
      dispatch(setSuccessTextSnackBar("Modificación exitosa"))
      return response.data?.data
    } catch (error) {
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error en un servicio de: e-Ventanilla",
          ),
        )
      }
      return null
    }
  }
}

export const getAllSubsDelegationVE = (
  customerSuborganizationCuit = null,
  customerSuborganizationName = null,
  accessDelegationDateTime = null,
  subscriptionDelegationId = null,
  page = 1,
  perPage = 10,
  setData = true,
  delegationAcceptationUser = null,
  stateCUIT = null,
) => {
  return async (dispatch) => {
    try {
      let isServiceEnabled = null
      let clientME = null
      let clientWithRemarks = null


      switch (stateCUIT) {
        case "isServiceEnabled":
          isServiceEnabled = true
          break
        case "clientME":
          isServiceEnabled = false
          break
        case "clientWithRemarks":
          clientWithRemarks = true
          break
        case "none":
          clientME = false
          break
        default:
          break
      }

      const response = await getAllSubscriptionDelegationsVE({
        customerSuborganizationCuit,
        customerSuborganizationName,
        accessDelegationDateTime,
        subscriptionDelegationId,
        delegationAcceptationUser,
        isServiceEnabled,
        clientME,
        clientWithRemarks,
        page,
        perPage,
      })

      const data = response.data.data
      const pagination = response.data.pagination
      setData &&
        dispatch(
          getSubscriptionSuccess({
            data,
            pagination,
          }),
        )

      return data
    } catch (error) {
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error en un servicio de: e-Ventanilla",
          ),
        )
      }
      throw error
    }
  }
}

export const getUniqueCustomerSuborganizationNames = () => {
  return async (dispatch) => {
    try {
      const response = await getUniqueCustomerSuborganizationNamesVE()
      const data = response?.data?.data || []
      const names = data.map((item) => item.customerSuborganizationName)
      dispatch(setSubscriptionClientNames(names))
    } catch (error) {
      console.error("Error al obtener todos los usuarios:", error)
      dispatch(setSubscriptionClientNames([]))
    }
  }
}

export const getUniqueEmailsFromSubscriptionDelegations = () => {
  return async (dispatch) => {
    try {
      const response = await getUniqueEmailsFromSubscriptionDelegationsVE()

      const data = response?.data?.data || []
      const emails = data.map((item) => item.email)

      dispatch(setSubscriptionUserNames(emails))
    } catch (error) {
      console.error("Error al obtener todos los usuarios:", error)
      dispatch(setSubscriptionUserNames([]))
    }
  }
}
